import { createRequest } from '../../../services/request';

export const LOAD_STORE_ACTOR_BY_CLAIM_ID = createRequest(
  'CLAIMS/LOAD_STORE_ACTOR_BY_CLAIM_ID',
);
export const SET_STORE_ACTOR = createRequest('CLAIMS/SET_STORE_ACTOR');
